'use client'

import { ToolLandingTemplate } from '../_components/tool-landing-template'
import { ai_landing_page_copy_generatorConfig } from './config'
import type { User } from '@/lib/types'
import { ChatKitPageWrapper } from '@/app/chatkit/_components/chatkit-page-wrapper'
import { getChatKitConstants } from '@/app/chatkit/design/_const'
import { useTranslations } from 'next-intl'
import { FileTextIcon } from 'lucide-react'

interface ai_landing_page_copy_generatorClientProps {
  user: User | null
  userApiKey: string
}

export default function ai_landing_page_copy_generatorClient({
  user,
  userApiKey,
}: ai_landing_page_copy_generatorClientProps) {
  const t = useTranslations('business-plan')
  const constants = getChatKitConstants(t)

  const agentSection =
    user && userApiKey ? (
      <ChatKitPageWrapper
        user={user}
        userApiKey={userApiKey}
        workflowKey="design"
        constants={constants}
        t={t}
        icon={FileTextIcon}
        hideHeader={true}
      />
    ) : (
      <div className="text-center py-8">
        <div className="max-w-2xl mx-auto mb-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Preview how your content will be generated
          </h3>
          <p className="text-gray-700 text-lg leading-relaxed font-medium">
            The HeyBoss AI agent helps you create professional content. Sign in
            to start generating.
          </p>
        </div>

        <div className="flex justify-center gap-4">
          <a
            href="/signup"
            className="inline-flex items-center justify-center rounded-lg bg-amber-600 px-8 py-4 text-lg font-semibold text-white shadow-lg hover:bg-amber-700 transition-colors"
          >
            Create free HeyBoss account
          </a>
          <a
            href="/login?redirect=/tool/ai-landing-page-copy-generator"
            className="inline-flex items-center justify-center rounded-lg border-2 border-gray-300 bg-white px-8 py-4 text-lg font-semibold text-gray-900 hover:bg-gray-50 transition-colors"
          >
            Sign in to continue
          </a>
        </div>
      </div>
    )

  return (
    <ToolLandingTemplate
      user={user}
      config={ai_landing_page_copy_generatorConfig}
      agentSection={agentSection}
    />
  )
}
